const Lightbulb = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66732 11.7721V13.333C6.66732 14.0694 7.26427 14.6663 8.00065 14.6663C8.73703 14.6663 9.33398 14.0694 9.33398 13.333V11.7721M8.00065 1.33301V1.99967M2.00065 7.99967H1.33398M3.66732 3.66634L3.26725 3.26628M12.334 3.66634L12.7342 3.26628M14.6673 7.99967H14.0007M12.0007 7.99967C12.0007 10.2088 10.2098 11.9997 8.00065 11.9997C5.79151 11.9997 4.00065 10.2088 4.00065 7.99967C4.00065 5.79054 5.79151 3.99967 8.00065 3.99967C10.2098 3.99967 12.0007 5.79054 12.0007 7.99967Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Lightbulb;
